import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { type NodeMouseHandler } from '@xyflow/react'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { type CustomNode } from './types'

const useNodeNavigation = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const onNodeClick: NodeMouseHandler<CustomNode> = useCallback(
    (_, node: CustomNode) => {
      navigate(navigation.employees.jobCatalog.overview.node.fullPath({ id: node.id }))
    },
    [navigate, navigation]
  )

  return { onNodeClick }
}

export default useNodeNavigation
